import * as React from 'react';
import {
    DndContext as CoreDndContext,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    type DndContextProps,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

function DndContext(props: DndContextProps): React.ReactElement {
    const defaultSensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
        useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
    );

    const { sensors, ...rest } = props;

    return <CoreDndContext sensors={sensors ?? defaultSensors} {...rest} />;
}

export default DndContext;

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('DndContext', async () => {
        const testModule = '@test';
        const { render } = await import(/* @vite-ignore */ testModule);

        it('matches snapshot', () => {
            const result = render(<DndContext />);
            expect(result.container).toMatchSnapshot();
        });
    });
}

// #endregion
